<template>
  <div v-if="dataPermission.includes('CNPS_SCON_REFUND_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách yêu cầu hoàn tiền</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="$bvModal.show('receipt-code'), refreshData()"
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_SCON_REFUND_CREATE')"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          @click="exportExcel"
          v-if="dataPermission.includes('CNPS_SCON_REFUND_VIEW')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input v-model.trim="search.code" placeholder="Từ khoá" />
          </div>
          <div class="form-group">
            <input v-model.trim="search.receiptCode" placeholder="Mã phiếu thu" />
          </div>
          <div class="form-group">
            <input v-model.trim="search.serial" placeholder="Serial" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.reason" :options="optionReason" placeholder="Lý do hoàn tiền">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.kpiStatus"
              :options="Config.getSearch(Config.kpiStatus)"
              placeholder="Tình trạng KPI"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.creatorId" :options="optionCreator" placeholder="Người tạo">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng nhóm công việc</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataRefund"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(createdTime)="data">
                {{ data.item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(creator)="data">
                {{ data.item.creator ? data.item.creator.name : '' }} <br />
                <span class="text-primary">{{
                  data.item.creator ? data.item.creator.email : ''
                }}</span>
              </template>
              <template #cell(merchant)="data">
                {{ data.item.mcName }} <br />
                {{ data.item.mcPhone | encryptPhone }} <br />
                <span class="text-primary">{{ data.item.mcEmail }}</span> <br />
                {{ data.item.mcAddress }}
              </template>
              <template #cell(reason)="data">
                {{ data.item.reason | mapTextStatus(optionReason) }}
              </template>
              <template #cell(receipt)="data">
                <a href="javascript:;" @click="openReiceipt(data.item)">{{
                  data.item.receiptCode
                }}</a
                ><br />
                Ngày thu: {{ data.item.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(contract)="data">
                <a href="javascript:;" @click="openContract(data.item)">{{
                  data.item.contractCode
                }}</a
                ><br />
                Ngày ký: {{ data.item.signTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(kpiStatus)="data">
                {{ data.item.kpiStatus | transformData(Config.kpiStatus) }}
              </template>
              <template #cell(refundAmount)="data">
                {{ data.item.refundAmount | transformMoney }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | mapTextStatus(optionStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="detailRefund(data.item.id)">Chi tiết</b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      (canEdit(data.item.status) && data.item.reason == 'SOFTWARE_DEVICE') ||
                      (data.item.reason == 'RENT_LEND' &&
                        dataPermission.includes('CNPS_SCON_REFUND_EDIT'))
                    "
                    @click="editRefundModal(data.item), (actionKey = 'EDIT')"
                    >Sửa</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      canEdit(data.item.status) &&
                      data.item.reason == 'CONTRACT_COINCIDENCE' &&
                      dataPermission.includes('CNPS_SCON_REFUND_EDIT')
                    "
                    @click="editRefundContractModal(data.item), (actionKey = 'EDIT')"
                    >Sửa</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="canEdit(data.item.status)"
                    @click="sendApprove(data.item.id)"
                    >Gửi duyệt</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      canApprovenReject(data.item.status) &&
                      dataPermission.includes('CNPS_SCON_REFUND_APPROVE')
                    "
                    @click="approve(data.item.id)"
                    >Duyệt</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      canApprovenReject(data.item.status) &&
                      dataPermission.includes('CNPS_SCON_REFUND_APPROVE')
                    "
                    @click="reject(data.item.id)"
                    >Từ chối</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      canCancel(data.item.status) &&
                      dataPermission.includes('CNPS_SCON_REFUND_CANCEL')
                    "
                    @click="changeStatus(data.item)"
                    >Huỷ</b-dropdown-item
                  >
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.size"
        ></b-pagination>
      </div>
    </div>

    <!--Nhập mã phiếu thu-->
    <b-modal id="receipt-code" centered size="lg">
      <template #modal-header="{ close }">
        <h5>Lý do hoàn tiền</h5>
        <b-button size="sm" variant="light" @click="close(), (codeCheck = '')"> x </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formReceiptCode">
        <form @submit.prevent="checkCode">
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider rules="required" vid="receiptCode" name="Lý do hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="reasonCheck"
                      :options="refundReason"
                      @change="queryReason($event)"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules=""
                vid="codeCheck"
                name="Mã phiếu thu"
                v-if="receiptCodeModal"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã phiếu thu<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="codeCheck" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="" name="" v-if="transactionCodeModal">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã giao dịch<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="transactionCheck" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkCode" v-if="receiptCodeModal"> Đồng ý </b-button>
        <b-button variant="primary" @click="checkDetail" v-if="transactionCodeModal">
          Đồng ý
        </b-button>
      </template>
    </b-modal>

    <!--Thêm/Sửa hoàn tiền-->
    <b-modal ignore-enforce-focus-selector="input" v-model="refundModal" centered size="lg">
      <template #modal-header="{ close }">
        <h5>{{ actionKey === 'EDIT' ? 'Sửa thông tin hoàn tiền' : 'Thêm thông tin hoàn tiền' }}</h5>
        <b-button
          size="sm"
          variant="light"
          @click="close(), (codeCheck = ''), fetchData(), (refundModal = false), refreshData()"
        >
          x
        </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formRefund">
        <form @submit.prevent="checkValidate">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="reason" name="Lý do hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <select
                      class="select"
                      v-model="reqRefund.reason"
                      :options="refundReason"
                      disabled
                    >
                      <option v-for="option in refundReason" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="receiptCode" name="Mã phiếu thu">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Mã phiếu thu</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.receiptCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="contractCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã hợp đồng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefund.contractCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Mã giao dịch đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">{{ reqRefund.transactionCode }}</p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Hình thức thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.paymentType | mapTextStatus(optionPaymentType) }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Ngày thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefund.payTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <ValidationProvider rules="required" vid="kpiStatus" name="Tình trạng KPI">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Tình trạng KPI</label>
                  <div class="col-sm-8">
                    <Select2 v-model="reqRefund.kpiStatus" :options="Config.kpiStatus"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <h6>Upload ảnh</h6>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in reqRefund.images" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImg(index)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="reqRefund.images && reqRefund.images.length < 10"
                      class="add-img"
                    >
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileImgRefund"
                        accept="image/jpeg, image/png"
                        @input="onSelectFile"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <h6 class="mb-2">Thông tin thiết bị/phần mềm hoàn tiền</h6>
          <div class="row">
            <div class="table-responsive text-center col-md-12">
              <table class="w-100 mb-2">
                <thead class="thead-gray">
                  <tr>
                    <th scope="col">
                      <input
                        type="checkbox"
                        class="text-center"
                        v-model="selectedPro"
                        :value="item"
                        @change="handleChange"
                      />
                    </th>
                    <th scope="col"><b>Loại sản phẩm</b></th>
                    <th scope="col"><b>Số tiền (VNĐ)</b></th>
                    <th scope="col" v-if="isRentLend"><b>Số tiền hoàn (VNĐ)</b></th>
                    <th scope="col"><b>Mã serial</b></th>
                    <th scope="col" v-if="isRentLend"><b>Khấu hao</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-row" v-for="(item, index) in listProduct" :key="index">
                    <td class="txt-center">
                      <input
                        type="checkbox"
                        class="text-center"
                        v-model="selectedPro"
                        :value="item"
                        @change="handleChange"
                      />
                    </td>
                    <td class="text-center">{{ item.type }}</td>
                    <td class="text-center">
                      {{ (isRentLend ? item.deposit : item.price) | transformMoney }}
                    </td>
                    <td class="text-center" v-if="isRentLend">
                      <input
                        type="number"
                        min="0"
                        placeholder="Nhập tiền"
                        v-model="item.refundAmount"
                        :disabled="selectedPro.indexOf(item) === -1"
                        @input="onRefundAmountChange(item)"
                      />
                    </td>
                    <td class="text-center">{{ item.serial }}</td>
                    <td class="text-center" v-if="isRentLend">{{ item?.depreciationAmount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <ValidationProvider
              rules="required|numberCheck"
              vid="reqRefund.refundAmount"
              name="Số tiền hoàn"
            >
              <div class="form-group d-flex flex-row" slot-scope="{ errors }">
                <label for="" class="col-sm-5 col-form-label"
                  ><i>Tổng số tiền hoàn/phiếu thu (VNĐ)</i><span style="color: red"> *</span></label
                >
                <div class="col-sm-7">
                  <input v-model.trim="textValue" :disabled="isRentLend" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </div>

          <h6 class="mb-2">Thông tin TKNH nhận tiền hoàn</h6>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="refundRecipient" name="Đối tượng hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Đối tượng hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="reqRefund.refundRecipient"
                      :options="objectRefund"
                      @change="queryObjectRefund($event)"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="bankName" name="Tên ngân hàng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên ngân hàng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8" v-if="reqRefund.refundRecipient === 'REFUND_MERCHANT'">
                    <select class="select" :options="listBank" v-model="reqRefund.bankId" disabled>
                      <option v-for="option in listBank" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                  <div class="col-sm-8" v-if="reqRefund.refundRecipient !== 'REFUND_MERCHANT'">
                    <Select2 :options="listBank" v-model="reqRefund.bankId"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountNumber"
                name="Số tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountNumber"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider rules="required|minMaxName_6" vid="branch" name="Chi nhánh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Chi nhánh <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.branch"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountName"
                name="Tên tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input
                      v-model.trim="reqRefund.accountName"
                      :disabled="reqRefund.refundRecipient === 'REFUND_MERCHANT'"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-12">
              <ValidationProvider rules="required|minMaxName_1" vid="note" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-2 col-form-label"
                    >Ghi chú<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-10">
                    <input v-model.trim="reqRefund.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkValidate"> Đồng ý </b-button>
      </template>
    </b-modal>

    <!-- Modal Hoàn tiền do thanh toán trùng hợp đồng  -->
    <b-modal ignore-enforce-focus-selector="input" v-model="refundContractModal" centered size="lg">
      <template #modal-header="{ close }">
        <h5>Thông tin hoàn tiền</h5>
        <b-button
          size="sm"
          variant="light"
          @click="
            close(), (codeCheck = ''), fetchData(), (refundContractModal = false), refreshData()
          "
        >
          x
        </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formRefund">
        <form @submit.prevent="checkValidateContract">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="reason" name="Lý do hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <select
                      class="select"
                      v-model="reqRefundContract.reason"
                      :options="refundReason"
                      disabled
                    >
                      <option v-for="option in refundReason" :value="option.id" :key="option.id">
                        {{ option.text }}
                      </option>
                    </select>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="contractCode" name="Mã hợp đồng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã hợp đồng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefundContract.contractCode" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">Mã giao dịch đã thu</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefundContract.transactionCode }}
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-4 col-form-label">Ngày thanh toán</label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12 ml-1">
                    {{ reqRefundContract.payTime | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>
              <ValidationProvider rules="" vid="refundAmount" name="Số tiền hoàn">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Số tiền hoàn</label>
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefundContract.refundAmount" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="kpiStatus" name="Tình trạng KPI">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Tình trạng KPI</label>
                  <div class="col-sm-8">
                    <Select2
                      v-model="reqRefundContract.kpiStatus"
                      :options="Config.kpiStatus"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <h6>Upload ảnh</h6>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in reqRefundContract.images" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImgContract(index)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="reqRefundContract.images && reqRefundContract.images.length < 10"
                      class="add-img"
                    >
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileImgRefundContract"
                        accept="image/jpeg, image/png"
                        @input="onSelectFileContract"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <h6 class="mb-2">Thông tin TKNH nhận tiền hoàn</h6>
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="refundRecipient" name="Đối tượng hoàn tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Đối tượng hoàn tiền<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2
                      v-model="reqRefundContract.refundRecipient"
                      :options="objectRefund"
                      @change="queryObjectRefund($event)"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="bankName" name="Tên ngân hàng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên ngân hàng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2 :options="listBank" v-model="reqRefundContract.bankId"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountNumber"
                name="Số tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefundContract.accountNumber" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <ValidationProvider rules="required|minMaxName_6" vid="branch" name="Chi nhánh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Chi nhánh <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefundContract.branch" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="required|minMaxName_6"
                vid="accountName"
                name="Tên tài khoản"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên tài khoản <span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqRefundContract.accountName" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-12">
              <ValidationProvider rules="required|minMaxName_1" vid="note" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-2 col-form-label"
                    >Ghi chú<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-10">
                    <input v-model.trim="reqRefundContract.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkValidateContract" v-if="actionKey == 'ADD'">
          Thêm mới
        </b-button>
        <b-button variant="primary" @click="checkValidateContract" v-if="actionKey == 'EDIT'">
          Sửa
        </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import { ReceiptService } from '@/services/receipts.service'
  import { StaffService } from '@/services/staff.service'
  import { CommonService } from '@/services/common.service'
  import { BankService } from '@/services/bank.service'
  import moment from 'moment'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import mxItemAction from './mx-item-action.js'
  import cloneDeep from 'lodash/cloneDeep'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'createdTime', label: 'Thời gian tạo' },
    { key: 'code', label: 'Mã BBHT' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'serial', label: 'Serial TB' },
    { key: 'reason', label: 'Lý do hoàn tiền' },
    { key: 'refundAmount', label: 'Số tiền hoàn' },
    { key: 'receipt', label: 'Phiếu thu' },
    { key: 'contract', label: 'Hợp đồng' },
    { key: 'kpiStatus', label: 'Tình trạng KPI' },
    { key: 'reasonReject', label: 'Lý do từ chối' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'creator', label: 'Người tạo' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
    },
    data() {
      return {
        Config,
        showLoading: false,
        loading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataRefund: [],
        filterTable: fieldsTable,
        fieldsTable,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        optionReason: [{ id: '0', text: 'Tất cả' }, ...Config.refundReason],
        optionObjectRefund: [{ id: '0', text: 'Tất cả' }, ...Config.refundRecipient],
        objectRefund: Config.refundRecipient,
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        optionCreator: [],
        optionStatus: [{ id: '0', text: 'Tất cả' }, ...Config.refundReportStatus],
        optionPaymentType: Config.typePayment,
        refundModal: false,
        refundContractModal: false,
        reqRefund: {
          images: [],
        },
        reqRefundContract: {
          images: [],
        },
        refundReason: Config.refundReason,
        actionKey: '',
        originalRefundItem: null,
        listProduct: [],
        selectedPro: [],
        listBank: [],
        customerRes: {},
        codeCheck: '',
        transactionCheck: '',
        reasonCheck: '',
        reasonContractCheck: '',
        receiptCodeModal: false,
        transactionCodeModal: false,
        loadingImage: false,
        textValue: '',
      }
    },
    mixins: [prepareQueryParamsMixin, mxItemAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      isRentLend() {
        return this.reqRefund.reason === 'RENT_LEND' || this.reasonCheck === 'RENT_LEND'
      },
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectProducts: {
        get: function () {
          return this.listProduct ? this.selectedPro.length === this.listProduct.length : false
        },
        set: function (value) {
          var selectedPro = []
          if (value) {
            this.listProduct.forEach(function (item) {
              selectedPro.push(item)
            })
          }
          this.selectedPro = selectedPro
        },
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      selectedPro: {
        handler: function () {
          this.calculateTotalRefund()
        },
        deep: true,
      },
    },
    filters: {
      checkReason(value) {
        if (value === 'CONTRACT_COINCIDENCE') {
          return 'hehehehehehehe'
        }
      },
    },
    created() {
      this.fetchData()
      this.listCreator()
      this.getListBank()
    },
    methods: {
      queryReason(e) {
        if (e !== 'CONTRACT_COINCIDENCE') {
          this.receiptCodeModal = true
          this.transactionCodeModal = false
        } else {
          this.receiptCodeModal = false
          this.transactionCodeModal = true
        }
      },
      detailRefund(idRefund) {
        window.open(`/list-refund/${idRefund}`, '_blank')
      },
      async onSelectFile() {
        const input = this.$refs.fileImgRefund
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0])
      },
      async onSelectFileContract() {
        const input = this.$refs.fileImgRefundContract
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3Contract(files[0])
      },
      removeImg(index) {
        this.reqRefund.images.splice(index, 1)
      },
      removeImgContract(index) {
        this.reqRefundContract.images.splice(index, 1)
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqRefund.images.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      async uploadS3Contract(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqRefundContract.images.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      async getListBank() {
        try {
          const data = await BankService.listBank()
          if (data.success) {
            this.listBank = data.data.map(e => {
              return {
                id: e.id,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async checkDetail() {
        const isSuccess = await this.$refs.formReceiptCode.validate()
        if (!isSuccess) {
          return
        }
        this.$bvModal.hide('receipt-code')
        const data = await BankService.merchantBankDetail({
          transactionCode: this.transactionCheck,
        })
        if (data.success) {
          this.reqRefundContract.reason = this.reasonCheck
          this.reqRefundContract.transactionCode = data.data.transactionCode
          this.reqRefundContract.payTime = data.data.payTime
          this.reqRefundContract.refundAmount = Number(data.data.amount)
          this.refundContractModal = true
          this.actionKey = 'ADD'
        } else {
          this.showFailMx(data.message)
        }
      },
      async checkCode() {
        const isSuccess = await this.$refs.formReceiptCode.validate()
        if (!isSuccess) {
          return
        }
        this.$bvModal.hide('receipt-code')
        const data = await BankService.merchantBank({
          code: this.codeCheck,
          reason: this.reasonCheck,
        })
        if (data.success) {
          this.reqRefund.reason = this.reasonCheck
          this.reqRefund.receiptCode = this.codeCheck
          this.customerRes = data.data.customerRes
          this.listProduct = data.data.infoProducts
          this.reqRefund.payTime = data.data.payTime
          this.reqRefund.paymentType = data.data.paymentType
          this.reqRefund.receiptTime = data.data.receiptTime
          this.reqRefund.transactionCode = data.data.transactionCode
          this.reqRefund.contractCode = data.data.contractCode
          this.refundModal = true
          this.actionKey = 'ADD'
        } else {
          this.showFailMx(data.message)
        }
      },
      queryObjectRefund(e) {
        if (e === 'REFUND_MERCHANT') {
          this.reqRefund = {
            ...this.reqRefund,
            bankId: this.customerRes.bankId,
            bankName: this.customerRes.bankName,
            accountNumber: this.customerRes.accountNo,
            branch: this.customerRes.branch,
            accountName: this.customerRes.holderName,
          }
        } else {
          delete this.reqRefund.bankId
          delete this.reqRefund.bankName
          delete this.reqRefund.accountNumber
          delete this.reqRefund.branch
          delete this.reqRefund.accountName
        }
      },
      async editRefundModal(item) {
        this.originalRefundItem = item
        this.reqRefund = cloneDeep(item)
        this.reqRefund.refundHistoryId = item.id

        let data = null
        if (this.isRentLend) {
          data = await BankService.merchantBankV1({
            code: item.receiptCode,
            refundHistoryId: item.id,
          })
        } else {
          data = await BankService.merchantBank({
            code: item.receiptCode,
          })
        }

        if (data.success) {
          this.listProduct = data.data.infoProducts
          this.customerRes = data.data.customerRes
          this.textValue = item.refundAmount

          // Logic mới: Tự động tick checkbox cho items có refundAmount
          this.selectedPro = []
          if (item.infoProducts && Array.isArray(item.infoProducts)) {
            item.infoProducts.forEach(product => {
              if (product.refundAmount && product.refundAmount !== 0) {
                // Tìm product tương ứng trong listProduct và thêm vào selectedPro
                const matchingProduct = this.listProduct.find(p => p.serial === product.serial)
                if (matchingProduct) {
                  // Copy refundAmount vào listProduct item
                  matchingProduct.refundAmount = product.refundAmount
                  this.selectedPro.push(matchingProduct)
                }
              }
            })
          }
        }
        this.refundModal = true
      },
      async editRefundContractModal(item) {
        this.$bvModal.hide('receipt-code')
        this.reqRefund = item
        this.reqRefund.refundHistoryId = item.id
        const data = await BankService.merchantBankDetail({
          transactionCode: this.reqRefund.transactionCode,
        })
        if (data.success) {
          this.reqRefundContract.reason = item.reason
          this.reqRefundContract.transactionCode = data.data.transactionCode
          this.reqRefundContract.payTime = data.data.payTime
          this.reqRefundContract.amount = data.data.amount
          this.reqRefundContract.refundAmount = Number(item.refundAmount)
          this.reqRefundContract.refundRecipient = item.refundRecipient
          this.reqRefundContract.bankId = item.bankId
          this.reqRefundContract.accountNumber = item.accountNumber
          this.reqRefundContract.accountName = item.accountName
          this.reqRefundContract.branch = item.branch
          this.reqRefundContract.contractCode = item.contractCode
          this.reqRefundContract.refundHistoryId = item.refundHistoryId
          this.reqRefundContract.note = item.note
          this.reqRefundContract.images = item.images || []
          this.refundContractModal = true
        } else {
          this.showFailMx(data.message)
        }
      },
      async checkValidate() {
        this.reqRefund.infoProducts = this.selectedPro
        this.reqRefund.refundAmount = Number(this.textValue)

        // For RENT_LEND reason, validate that at least one checkbox is selected
        // if (this.reqRefund.reason === 'RENT_LEND' && this.selectedPro.length === 0) {
        //   this.showFailMx('Vui lòng chọn ít nhất một thiết bị/phần mềm để hoàn tiền')
        //   return
        // }

        const isSuccess = await this.$refs.formRefund.validate()
        if (!isSuccess && this.reqRefund.infoProducts.length < 1) {
          return
        }
        if (isSuccess) {
          if (this.reqRefund.reason === 'REFUND_MERCHANT') {
            if (this.actionKey === 'ADD') {
              this.addRefund(this.reqRefund)
            } else {
              this.editRefund(this.reqRefund)
            }
          } else {
            this.checkBankAccount(this.reqRefund)
          }
        }
      },
      async checkValidateContract() {
        const isSuccess = await this.$refs.formRefund.validate()
        if (!isSuccess) {
          return
        }
        this.checkBankAccountContract(this.reqRefundContract)
      },
      async checkBankAccountContract(reqRefundContract) {
        this.reqRefundContract.refundAmount = Number(reqRefundContract.refundAmount)
        try {
          this.showLoading = true
          const data = await BankService.checkBank({
            bankId: reqRefundContract.bankId,
            holderName: reqRefundContract.accountName,
            accountNo: reqRefundContract.accountNumber,
          })
          if (data.success) {
            if (this.actionKey === 'ADD') {
              this.addRefund(this.reqRefundContract)
            } else this.editRefund(this.reqRefundContract)
          } else {
            if (data.code === 641 || data.code === 642) {
              const flag = await this.approveMx(
                'Trong một số trường hợp dịch vụ kiểm tra thông tin phía ngân hàng không ổn định, thông báo này cũng sẽ được hiển thị. Nếu đã đảm bảo tính xác thực của thông tin, bạn có thể chọn tiếp tục?'
              )
              if (flag === true) {
                await this.addRefund(reqRefundContract)
              }
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async checkBankAccount(reqRefund) {
        try {
          this.showLoading = true
          const data = await BankService.checkBank({
            bankId: reqRefund.bankId,
            holderName: reqRefund.accountName,
            accountNo: reqRefund.accountNumber,
          })
          if (data.success) {
            if (this.actionKey === 'ADD') {
              this.addRefund(this.reqRefund)
            } else {
              this.editRefund(this.reqRefund)
            }
          } else {
            if (data.code === 641 || data.code === 642) {
              const flag = await this.approveMx(
                'Trong một số trường hợp dịch vụ kiểm tra thông tin phía ngân hàng không ổn định, thông báo này cũng sẽ được hiển thị. Nếu đã đảm bảo tính xác thực của thông tin, bạn có thể chọn tiếp tục?'
              )
              if (flag === true) {
                if (this.actionKey === 'ADD') {
                  await this.addRefund(reqRefund)
                } else {
                  await this.editRefund(reqRefund)
                }
              }
            } else {
              this.showFailMx(data.message)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async addRefund(reqRefund) {
        try {
          this.showLoading = true
          this.refundModal = false
          this.refundContractModal = false
          const req = cloneDeep(reqRefund)
          req.bankName = this.listBank.find(s => s.id === req.bankId)?.text ?? ''
          const data = await ReceiptService.createRefund(req)
          if (data.success) {
            await this.fetchData()
            this.showSuccessMx('Tạo thông tin hoàn tiền thành công')
            this.codeCheck = ''
          } else {
            this.showFailMx(data.message)
          }
          this.reqRefund = {
            images: [],
          }
          this.selectedPro = []
          delete this.reqRefund.bankId
          delete this.reqRefund.bankName
          delete this.reqRefund.accountNumber
          delete this.reqRefund.branch
          delete this.reqRefund.accountName
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },

      async editRefund(reqRefund) {
        try {
          this.showLoading = true
          this.refundModal = false
          this.refundContractModal = false
          const req = cloneDeep(reqRefund)
          req.bankName = this.listBank.find(s => s.id === req.bankId)?.text ?? ''
          const data = await ReceiptService.editRefund(req)
          if (data.success) {
            // Update original item in list
            if (this.originalRefundItem) {
              Object.assign(this.originalRefundItem, req)
            }
            delete this.reqRefund.refundHistoryId
            this.showSuccessMx('Sửa thông tin hoàn tiền thành công')
          } else {
            this.showFailMx(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },

      async listCreator() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.success) {
            this.optionCreator = data.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
              }
            })
            this.optionCreator.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          console.log(e)
        }
      },
      transfromDate() {
        this.search.dateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      async exportExcel() {
        try {
          this.showLoading = true
          delete this.search.page
          delete this.search.limit
          await ReceiptService.exportRefund(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const params = cloneDeep(this.search)
          for (const key in params) {
            if (params[key] === '0') delete params[key]
          }
          const data = await ReceiptService.listRefund(params)
          if (data.success) {
            this.dataRefund = data.data.refundList
            this.pagination.total = data.data.count
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },

      calculateTotalRefund() {
        if (this.isRentLend) {
          // Logic cho RENT_LEND: Tổng = tổng deposit của items được chọn + tổng refundAmount đã nhập
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            // const deposit = Number(item.deposit) || 0
            const refundAmount = Number(item.refundAmount) || 0
            return total + refundAmount
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        } else {
          // Logic cho các reason khác: Tổng = tổng price của items được chọn
          const totalRefundAmount = this.selectedPro.reduce((total, item) => {
            const price = Number(item.price) || 0
            return total + price
          }, 0)
          this.reqRefund.refundAmount = totalRefundAmount
          this.textValue = totalRefundAmount
        }
      },

      // Thay thế method handleChange
      handleChange() {
        this.$nextTick(() => {
          this.calculateTotalRefund()
        })
      },

      // Thêm method để handle khi input refundAmount thay đổi
      onRefundAmountChange(item) {
        // Validate refundAmount không được âm
        if (item.refundAmount < 0) {
          item.refundAmount = 0
        }
        this.$nextTick(() => {
          this.calculateTotalRefund()
        })
      },
      openReiceipt(data) {
        window.open(`/detail-receipts/${data.receiptId}`)
      },
      openContract(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.contractId)}`, '_blank')
          } else {
            window.open(
              `/sales-manager/detail-paper/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(
              `/contract-detail-ecommerce/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.contractId)}`, '_blank')
          }
        }
      },
      refreshData() {
        delete this.transactionCheck
        this.codeCheck = ''
        this.reasonCheck = ''
        delete this.reqRefund.bankId
        delete this.reqRefund.bankName
        delete this.reqRefund.accountNumber
        delete this.reqRefund.branch
        delete this.reqRefund.accountName
        delete this.reqRefund.refundRecipient
        delete this.reqRefund.note
        delete this.reqRefundContract.bankId
        delete this.reqRefundContract.bankName
        delete this.reqRefundContract.accountNumber
        delete this.reqRefundContract.branch
        delete this.reqRefundContract.accountName
        delete this.reqRefundContract.refundRecipient
        delete this.reqRefundContract.refundAmount
        delete this.reqRefundContract.contractCode
        delete this.reqRefundContract.note
        this.textValue = ''
      },
    },
  }
</script>

<style scoped>
  table th {
    background-color: #dee2e6;
    border: 1px solid #cacaca;
  }

  .select {
    background-color: #e2e7ed;
    border: 1px solid #ccc;
  }
</style>
